import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import SearchBox from "../../../../Component/DigitalMarketing/SearchBox";
import DashTabs from "./DashTabs";
import DashTable from "./DashTable";
import LocationDetails from "./LocationDetails";
import { useGetLocationsMasterQuery } from "../../../../Service/Masters";
import Pagination from "../../../../Component/DigitalMarketing/Pagination";
import { useDispatch } from "react-redux";
import { Change } from "../../../../store/async-actions/digitalmarketing/header";
import Loader from "../../../../Component/DigitalMarketing/Loader";

const Locations = () => {
  const [show, setShow] = useState(false);
  const [updateData, setUpdateData] = useState<any>([]);
  const [pagination, setpagination] = useState(1);
  const [searchValue, setSearchValue] = useState("");
  const dispatch = useDispatch()
  const pagi = {
    pageNo: pagination,
    name: searchValue,
  };
  const { data: locationData, refetch,isLoading } = useGetLocationsMasterQuery(pagi, {
    refetchOnMountOrArgChange: true,
  });
  const onChangeSearch = (event) => {
    setSearchValue(event.target.value);
  };
  useEffect(() => {
    setpagination(1);
    refetch();
  }, [searchValue]);
  useEffect(() => {
    const data: any = {
      first: "Branches",
    };
    dispatch(Change(data));
  }, [show]);
  if (isLoading) {
    return <Loader loading={true}/>;
  }
  return (
    <div>
      <Row>
        <Col md={5}>
          <SearchBox
            value={searchValue}
            onChange={(event) => onChangeSearch(event)}
          />
        </Col>
        <Col md={7} className="d-flex justify-content-end">
          <DashTabs
            setShow={setShow}
            show={show}
            setUpdateData={setUpdateData}
            // setView={setView}
          />
        </Col>
      </Row>

      <div className="row">
        <div className={show ? "col-8" : "col-12"}>
          <DashTable
            setShow={setShow}
            locationData={locationData}
            setUpdateData={setUpdateData}
            // setView={setView}
            refetch={refetch}
          />
        </div>
        {show && (
          <div
            className="col-4 "
            style={{
              backgroundColor: "white",
              minHeight: "70vh",
              overflowY: "auto",
            }}
          >
            <LocationDetails
              refetch={refetch}
              updateData={updateData}
              setShow={setShow}
            />
          </div>
        )}
        <Pagination
          setpagination={setpagination}
          pagination={pagination}
          data={locationData}
        />
      </div>
    </div>
  );
};

export default Locations;
